module.exports = __webpack_public_path__ + "static/media/BTS_FINALS-12.448ebb23.jpg";